module.exports = __webpack_public_path__ + "img/alert-active.cdc19ea3.svg";